var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"link","disabled":_vm.busy},on:{"click":_vm.create_new}},[(_vm.busy)?_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"fa-solid fa-spinner"}}):_c('font-awesome-icon',{attrs:{"icon":"fa-light fa-receipt"}}),_c('span',[_vm._v("New Order")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }